import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { renderHtmlToReact } from '@src/utils/html';
import { options } from '@src/utils/renderOptions';

export const getHowItWorksSectionViewModel = (sections = []) => {
  if (!sections) {
    return null;
  }

  const data = sections.find(
    (section) =>
      section.internal.type === 'ContentfulSavybiuSkiltis' &&
      section.layout === 'Su video'
  );

  return data
    ? {
        title: data.title,
        description:
          data?.description?.raw &&
          documentToReactComponents(JSON.parse(data.description.raw), options),
        videoUrl: data.video,
        steps: data.features.map((feature) => ({
          icon: feature.icon?.file?.url,
          title: feature.title,
          description:
            feature?.description?.childMarkdownRemark?.htmlAst &&
            renderHtmlToReact(feature.description.childMarkdownRemark.htmlAst),
        })),
        buttonText: data.buttonText,
        buttonLink: data.buttonLink,
      }
    : null;
};
